<script>
    export default {
        name: 'modal-component',
        props: {
            isOpen: {
                type: Boolean,
                required: true
            },
            withTopCloseBtn: {
                type: Boolean,
                default: false
            },
            withSubmitBtn: {
                type: Boolean,
                default: true
            },
            withCloseBtn: {
                type: Boolean,
                default: true
            },
            title: {
                type: String,
                default: "Modal Title"
            },
            content: {
                type: String,
                default: ""
            },
            list: {
                type: Array,
            },
            buttonText: {
                type: String,
                default: "Submit"
            },
            closeButtonText: {
                type: String,
                default: "Close"
            },
        },
        data(){
            return{
                data: [],
            }
        },
        watch: {
            data: {
                immediate: true,
                handler(newVal) {
                    this.data = newVal;
                },
            },
        },
        methods: {
            handleCloseButton() {
                this.$emit("close");
            },
            handleSubmitButton() {
                this.$emit("submit");
            },
        },
        mounted(){

        }
    };
</script>